var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreejs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_13065)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0830202 0.0749727C0.152694 0.0085635 0.25284 -0.0160197 0.345772 0.0104743L23.8041 6.69825C23.8971 6.72477 23.9688 6.79844 23.992 6.89149C24.0153 6.98453 23.9867 7.0828 23.9169 7.14925L6.31038 23.9198C6.24064 23.9862 6.1404 24.0108 6.04743 23.9842C5.95447 23.9576 5.8829 23.8839 5.85969 23.7908L0.00790924 0.332506C-0.0152817 0.239539 0.0133464 0.141382 0.0830202 0.0749727ZM0.646123 0.654263L6.27303 23.2111L23.203 7.08504L0.646123 0.654263Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0708 3.35527C12.1638 3.38187 12.2354 3.4556 12.2586 3.54867L15.1824 15.2813C15.2056 15.3743 15.1769 15.4724 15.1072 15.5388C15.0375 15.6052 14.9374 15.6298 14.8445 15.6033L3.12181 12.2583C3.02882 12.2318 2.9572 12.1581 2.93392 12.0651C2.91065 11.9721 2.93926 11.8739 3.00897 11.8074L11.8078 3.41971C11.8776 3.35323 11.9778 3.32866 12.0708 3.35527ZM3.72269 11.8716L14.5443 14.9594L11.8452 4.1286L3.72269 11.8716Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.44686 7.57014C7.51648 7.50375 7.61656 7.47913 7.70946 7.50553L13.5335 9.16105C13.6265 9.1875 13.6982 9.26109 13.7216 9.35411C13.7449 9.44712 13.7164 9.5454 13.6467 9.61192L9.27491 13.7848C9.20519 13.8513 9.10489 13.8759 9.01186 13.8494C8.91882 13.8228 8.84719 13.749 8.824 13.6559L7.37178 7.82755C7.34863 7.73463 7.37724 7.63653 7.44686 7.57014ZM8.00977 8.14894L9.23733 13.0757L12.9328 9.54834L8.00977 8.14894Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25705 1.68435C6.35008 1.71093 6.42171 1.78468 6.44491 1.87778L7.89712 7.70615C7.92027 7.79908 7.89166 7.89718 7.82204 7.96357C7.75242 8.02996 7.65234 8.05458 7.55944 8.02817L1.73542 6.37265C1.64239 6.34621 1.57068 6.27261 1.54732 6.1796C1.52396 6.08659 1.5525 5.9883 1.62219 5.92179L5.994 1.74893C6.06372 1.68239 6.16401 1.65776 6.25705 1.68435ZM2.33609 5.98536L7.25913 7.38477L6.03158 2.45805L2.33609 5.98536Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9046 5.00686C17.9976 5.03344 18.0692 5.10719 18.0924 5.20029L19.5446 11.0287C19.5678 11.1216 19.5392 11.2197 19.4696 11.2861C19.3999 11.3525 19.2999 11.3771 19.207 11.3507L13.3829 9.69516C13.2899 9.66872 13.2182 9.59512 13.1948 9.50211C13.1715 9.4091 13.2 9.31081 13.2697 9.2443L17.6415 5.07144C17.7112 5.0049 17.8115 4.98027 17.9046 5.00686ZM13.9836 9.30787L18.9067 10.7073L17.6791 5.78056L13.9836 9.30787Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16262 13.3382C9.25566 13.3647 9.32729 13.4385 9.35048 13.5316L10.8027 19.36C10.8259 19.4529 10.7972 19.551 10.7276 19.6174C10.658 19.6838 10.5579 19.7084 10.465 19.682L4.641 18.0265C4.54796 18 4.47626 17.9264 4.4529 17.8334C4.42954 17.7404 4.45808 17.6421 4.52777 17.5756L8.89958 13.4027C8.96929 13.3362 9.06959 13.3116 9.16262 13.3382ZM5.24167 17.6392L10.1647 19.0386L8.93715 14.1119L5.24167 17.6392Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_13065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreejs);
export default __webpack_public_path__ + "static/media/threejs.22310522f50128f809e3dd26ebaff525.svg";
export { ForwardRef as ReactComponent };